import { render, staticRenderFns } from "./OpenTelemetryIntegration.vue?vue&type=template&id=6abb9cb9&scoped=true"
import script from "./OpenTelemetryIntegration.vue?vue&type=script&lang=js"
export * from "./OpenTelemetryIntegration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abb9cb9",
  null
  
)

export default component.exports